import React from "react";

type Props = {
  content: string;
};

export const HtmlParser = ({ content }: Props) => {
  if (!content) return null;

  // remove HTML tags, except <b> and <br>
  const sanitizedText = content.replace(/<[^>]+>/g, (match) => {
    const lowerMatch = match.toLowerCase();
    if (lowerMatch === "<b>" || lowerMatch === "</b>") {
      return match;
    }
    if (/^<br\s*\/?>$/.test(lowerMatch)) {
      return "<br>";
    }
    return "";
  });

  const parts = sanitizedText.split(/(<b>|<\/b>|<br>)/gi);

  let isBold = false;
  let offset = 0;

  return (
    <>
      {parts.map((part) => {
        const key = String(offset);
        offset += part.length;

        const lowerPart = part.toLowerCase();

        if (lowerPart === "<b>") {
          isBold = true;
          return null;
        }
        if (lowerPart === "</b>") {
          isBold = false;
          return null;
        }
        if (lowerPart === "<br>") {
          return <br key={key} />;
        }

        if (!part) return null;

        return isBold ? <b key={key}>{part}</b> : <React.Fragment key={key}>{part}</React.Fragment>;
      })}
    </>
  );
};
